// eslint-disable-next-line import/no-unresolved
import { route } from 'ziggy';

export const backendRoute = (name, params = undefined, absolute = false) => {
    // On staging + production BE routes are prefixed with "/bewerben"
    const prefix = import.meta.env.MODE === 'development' ? '' : '/bewerben';
    return prefix + route(name, params, absolute, window.Ziggy);
};
